import React from "react";

const getPasswordScore = (password) => {
	if (!password) return 0;

	let score = 0;

	if (password.length >= 6) score += 1;
	if (password.length >= 10) score += 1;
	if (/[a-z]/.test(password) && /[A-Z]/.test(password)) score += 1;
	if (/\d/.test(password)) score += 1;
	if (/[^A-Za-z0-9]/.test(password)) score += 1;

	return Math.min(score, 4);
};

const levels = [
	{
		label: "Too weak",
		color: "bg-red-500",
		width: "20%",
		hint: "Add more characters and variety.",
	},
	{
		label: "Weak",
		color: "bg-orange-500",
		width: "40%",
		hint: "Use upper, lower, number, and symbol.",
	},
	{
		label: "Good",
		color: "bg-yellow-500",
		width: "70%",
		hint: "Longer passwords are safer.",
	},
	{
		label: "Strong",
		color: "bg-green-500",
		width: "100%",
		hint: "Looks strong. Keep it unique.",
	},
	{
		label: "Very strong",
		color: "bg-emerald-600",
		width: "100%",
		hint: "Great. Avoid reusing on other sites.",
	},
];

const PasswordStrength = ({ password, className = "" }) => {
	if (!password) return null;

	const score = getPasswordScore(password);
	const level = levels[score];

	return (
		<div className={`mt-1 text-xs ${className}`}>
			<div className="h-1.5 rounded-full bg-slate-200 overflow-hidden">
				<div className={`h-full ${level.color} transition-all duration-200`} style={{ width: level.width }} />
			</div>
			<div className="flex items-center justify-between mt-1 text-[11px] text-secondary">
				<span>{level.label}</span>
				<span className="text-right">{level.hint}</span>
			</div>
		</div>
	);
};

export default PasswordStrength;

